<div *ngIf="!skeleton" class="header">
  <h1>{{ title }}</h1>

  <div class="custom-user-title">
    <ng-content select="[slot='custom-title']"></ng-content>
  </div>
</div>

<opac-skeleton *ngIf="skeleton"></opac-skeleton>
